import { Inbox } from '@/components/inbox/inbox';
import amplitudeService from '@/services/amplitude';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_app/')({
  component: RouteComponent,
  onEnter: () => {
    amplitudeService.logEvent('Conversations Tab Opened');
  },
  validateSearch: z.object({
    focus: z.literal('message').optional(),
    contactId: z.string().optional(),
    callId: z.string().optional(),
    number: z.string().optional(), // Phone number for v2 conversations
    line: z.string().optional(), // Allo number (to_number) for line switching via deeplinks
    view: z.enum(['discussions', 'calls', 'summaries']).optional(),
    tab: z.enum(['summary', 'transcript', 'actions']).optional(),
    openPanel: z.boolean().optional(),
    body: z.string().optional(), // Prefilled SMS body for deep-link compose
    // Surface the user came from — drives the summary breadcrumb + back. `analytics`
    // is accepted because line-switch navigations carry it through from the
    // session-summary route; only `power-dialer` is acted on here.
    from: z.enum(['power-dialer', 'analytics']).optional(),
  }),
});

function RouteComponent() {
  return <Inbox />;
}
